export default {
    DESIGN_HASH:    'hash', // User does not want so create a design
    DESIGN_USER:    'user', // User wants to create own design
    DESIGN_BOTH:    'both', // Step can work in both modes
    current:        null,
    check: function(mode) { return mode === this.current || mode === this.DESIGN_BOTH },
}

